import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { agencyApiSelectors } from '../../../api/agency'
import styles from './TestAgencyPill.module.scss'

/** Ids of agencies flagged as test agencies, from the listing the page already fetches. */
export const useTestAgencyIds = (): Set<string> => {
  const agencyListing = useSelector(agencyApiSelectors.getAgencyListing)
  return useMemo(() => new Set((agencyListing ?? []).filter(a => a.isTestAgency).map(a => a.agencyId)), [agencyListing])
}

const TestAgencyPill = () => (
  <span className={styles.pill} title="Test agency">
    Test
  </span>
)

export default TestAgencyPill
